module.exports = __webpack_public_path__ + "img/avatar5.2a51499d.jpg";